import { Link, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { AccountSection } from "../components/settings/AccountSection";
import { CompaniesSection } from "../components/settings/CompaniesSection";
import { TeamSection } from "../components/settings/TeamSection";
import { Mail, Building2, Users } from "lucide-react";

const TABS = [
  { id: "conta", label: "Conta", icon: Mail },
  { id: "empresas", label: "Empresas", icon: Building2 },
  { id: "equipa", label: "Equipa", icon: Users, adminOnly: true },
];

export default function AccountantSettings() {
  const { user } = useAuth();
  const isAdmin = !!user?.is_admin;
  const [params, setParams] = useSearchParams();
  const tabs = TABS.filter((t) => !t.adminOnly || isAdmin);
  const requested = params.get("tab") || "conta";
  const active = tabs.some((t) => t.id === requested) ? requested : "conta";

  return (
    <div className="paper-grain min-h-screen">
      <Header />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8" data-testid="settings-page">
        <Link to="/contabilista" className="inline-flex items-center gap-2 text-sm text-[color:var(--ink-muted)] hover:text-[color:var(--ink)] mb-4" data-testid="back-to-dashboard">
          ← Voltar
        </Link>
        <span className="label-eyebrow block">definições</span>
        <h1 className="font-display text-3xl sm:text-4xl mt-2">Definições</h1>

        <div className="mt-6 flex flex-wrap gap-2 border-b border-[color:var(--border)] pb-px" data-testid="settings-tabs">
          {tabs.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              type="button"
              onClick={() => setParams({ tab: id })}
              className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-t-lg border-b-2 -mb-px transition-colors ${
                active === id
                  ? "border-[color:var(--primary)] text-[color:var(--primary)] bg-[color:var(--surface)]"
                  : "border-transparent text-[color:var(--ink-muted)] hover:text-[color:var(--ink)]"
              }`}
              data-testid={`settings-tab-${id}`}
            >
              <Icon size={15} /> {label}
            </button>
          ))}
        </div>

        <div className="mt-6">
          {active === "conta" && <AccountSection />}
          {active === "empresas" && <CompaniesSection />}
          {active === "equipa" && isAdmin && <TeamSection />}
        </div>
      </main>
    </div>
  );
}
